import React from 'react'
 import useSEO from "./useSEO";
const Quickbookaccounting = () => {
  useSEO({ 
  title: "QuickBooks Accounting Software | Smart Online Accounting Solutions",
  description: "Simplify your business finances with QuickBooks Accounting Software. Manage invoicing, expenses, payroll, GST, and reporting with ease — anytime, anywhere.",
  keywords: "QuickBooks accounting software, online accounting, QuickBooks GST software, QuickBooks payroll, QuickBooks invoicing, cloud accounting, QuickBooks bookkeeping, QuickBooks financial reporting",
  ogTitle: "QuickBooks Accounting Software - Smarter Business Finance",
  ogDescription: "Track expenses, manage invoices, and streamline accounting with QuickBooks.",
  ogImage: "img/quickbooks-accounting.png",
  twitterTitle: "QuickBooks Accounting Software - Smarter Business Finance",
  twitterDescription: "Your all-in-one online accounting solution — QuickBooks for effortless business management.",
  twitterImage: "img/quickbooks-accounting.png"
});

  return (
    <div>
        <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4"> QuickBooks Accounting Software</h1>
          <p className="mb-4">
            QuickBooks is a leading cloud-based accounting software designed to
            make financial management easy, efficient, and accurate. Trusted by
            millions of businesses worldwide, QuickBooks helps you manage your
            finances, track expenses, send invoices, process payroll, and stay
            tax-ready — all from one intuitive platform.
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img
            src="img/quickbook-accounting.png"
            alt="QuickBooks Accounting Software"
          />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            <img
              src="img/quickbook-accounting1.png"
              alt="QuickBooks Accounting Software"
            />
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4"> Key Features:</h2>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Invoicing &amp; Payments: </b>
                </li>
                <p>
                  {" "}
                  Create professional invoices, accept online payments, and
                  track customer transactions in real time.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Expense Tracking:</b>
                </li>
                <p>
                  {" "}
                  Automatically import bank transactions, categorize expenses,
                  and manage bills.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>GST &amp; Tax Compliance: </b>
                </li>
                <p>
                  {" "}
                  Easily generate GST-compliant invoices, prepare returns, and
                  manage deductions.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Real-Time Reporting:</b>
                </li>
                <p>
                  {" "}
                  Access P&amp;L statements, balance sheets, cash flow, and
                  other reports to make informed decisions./p&gt;
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Inventory Management:</b>
                </li>
                <p>
                  {" "}
                  Track stock levels, manage product listings, and automate
                  reordering.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Payroll Integration:</b>
                </li>
                <p>
                  {" "}
                  Calculate salaries, deductions, and taxes, and generate
                  payslips effortlessly.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Multi-Device Access: </b>
                </li>
                <p> Use it anytime, anywhere via desktop, mobile, or tablet.</p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

      
    </div>
  )
}

export default Quickbookaccounting
